<form class="form form_crm" [formGroup]="formGroup" novalidate>
  <div class="row no-gutters gutters-4 align-items-center" formGroupName="default">
    <div class="col-12">
      <div class="row mb-4 mt-2">
        <div class="col-md-6 mt-2">
          <div class="caption">Общие настройки для реализации квартир</div>
        </div>
        <!-- РАЗДЕЛЕННЫЙ СПИСОК ЗАСТРОЙЩИКОВ -->
        @if (data['developers']) {
          <div class="col-md-6 d-flex align-items-center flex-wrap">
            <!-- ГРУППА 1: Активные застройщики (с включенными ЖК) -->
            @if (developerGroups.active.length > 0) {
              <div class="developers-group active-developers">
                <div class="caption mr-2">Условия на застройщике:</div>
                @for (developer of developerGroups.active; track developer) {
                  <div class="caption-sm mr-3">
                    <a [routerLink]="['/condition/developer/',developer.id]">
                      {{developer.caption}}
                      @if (developer.is_condition) {
                        <span> (Внесено)</span>
                      }
                    </a>
                  </div>
                }
              </div>
            }

            <!-- ГРУППА 2: Неактивные застройщики (без включенных ЖК) -->
            @if (developerGroups.inactive.length > 0) {
              <div class="developers-group inactive-developers">
                @for (developer of developerGroups.inactive; track developer) {
                  <div class="caption-sm mr-3 text-muted">
                    <a [routerLink]="['/condition/developer/',developer.id]" class="text-muted">
                      {{developer.caption}}
                      @if (developer.is_condition) {
                        <span> (Внесено)</span>
                      }
                    </a>
                  </div>
                }
              </div>
            }

            <!-- Если нет ни активных, ни неактивных застройщиков -->
            @if (developerGroups.active.length === 0 && developerGroups.inactive.length === 0) {
              <div class="caption-sm text-muted">Нет доступных застройщиков</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="col-6 col-md-3 pt-2">
      <app-material-input-checkbox formControlName="is_active">
        Принимать на реализацию
      </app-material-input-checkbox>
    </div>
    <!--    <div class="col-4">-->
    <!--      <app-material-input formControlName="voznagr_agenta" [placeholder]="'Вознаграждение агента (ДБ)'">-->
    <!--        Вознаграждение агента (ДБ)-->
    <!--      </app-material-input>-->
    <!--    </div>-->
    <!--    <div class="col-4">-->
    <!--      <app-material-input formControlName="dolya_subagenta_db" [placeholder]="'Процент субагента (ДБ)'">-->
    <!--        Процент субагента ДБ (Доля <span class="bold">{{ formGroup.get('default').get('voznagr_agenta').value | partRate : formGroup.get('default').get('dolya_subagenta_db').value : 'front'}}</span>)-->
    <!--      </app-material-input>-->
    <!--    </div>-->
    <div class="col-6 col-md-3">
      <app-material-input-datepicker formControlName="srok_realisation" [placeholder]="'Действует до'">
        Действует до
      </app-material-input-datepicker>
    </div>
    <div class="col-6 col-md-3">
      <app-material-input formControlName="voznagr_agenta_from_ddu" [placeholder]="'Вознаграждение агента (ДДУ)'">
        Вознаграждение агента (ДДУ)
      </app-material-input>
    </div>
    <div class="col-6 col-md-3">
      <app-material-input formControlName="dolya_subagenta_agd" [placeholder]="'Процент субагента (АГД)'">
        Процент субагента АГД (Доля <span class="bold">{{ formGroup.get('default').get('voznagr_agenta_from_ddu').value | partRate : formGroup.get('default').get('dolya_subagenta_agd').value : 'front'}}</span>)
      </app-material-input>
    </div>
    <!--    <div class="col-sm-12">-->
    <!--      <app-material-input formControlName="unique_term_days" [placeholder]="'Срок уникальности клиента'">-->
    <!--        Срок уникальности клиента-->
    <!--      </app-material-input>-->
    <!--    </div>-->
    <!--    <div class="col-sm-12">-->
    <!--      <app-material-input-checkbox formControlName="lead_transfer_capability">-->
    <!--        Возможность передачи лида субагентом-->
    <!--      </app-material-input-checkbox>-->
    <!--    </div>-->
    <!--    <div class="col-sm-12">-->
    <!--      <div [hidden]="!formGroup.get('default').get('lead_transfer_capability').value">-->
    <!--        <app-material-input formControlName="lead_transfer_sub_percent_db" [placeholder]="'Процент субагента ДБ при передаче лида'">-->
    <!--          Процент субагента ДБ при передаче лида-->
    <!--        </app-material-input>-->
    <!--        <app-material-input formControlName="lead_transfer_sub_percent_agd" [placeholder]="'Процент субагента АГД при передаче лида'">-->
    <!--          Процент субагента АГД при передаче лида-->
    <!--        </app-material-input>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
  <hr>

  <div class="caption mb-2">Использовать общие настройки для реализации квартир</div>
  @if (complexes.controls.length) {
    <div class="row mb-2">
      <div class="col-12 col-sm-6 col-lg-3">
        <app-material-input [(ngModel)]="searchField" [ngModelOptions]="{standalone: true}" [error]="searchFieldError">
          Поиск ЖК
          @if (searchField !== '') {
            <span class="ml-3 badge align-top"
                  [class.badge-warning]="!searchFieldIds.length"
                  [class.badge-success]="searchFieldIds.length"
            >(найдено {{searchFieldIds.length}} из {{complexes.controls.length}})</span>
          }
        </app-material-input>
      </div>
    </div>
  }

  <div class="row no-gutters gutters-4 align-items-center" formArrayName="complexes">
    @if (!complexes.controls.length) {
      <div class="col-12 mb-2 mt-2 text-sm">В данный момент комплексов нет</div>
    }
    @for (complex of complexes.controls; track complex; let id = $index) {
      <div class="col-sm-6"
           [formGroupName]="id"
           [class.d-none]="!searchFieldError && searchField && searchFieldIds.indexOf(complex.value.id) === -1"
      >
        <app-material-input-checkbox formControlName="is_checked" [require]="true">
          {{ complex.value.caption }}
        </app-material-input-checkbox>
      </div>
    }
  </div>
  <div formArrayName="settings" class="end_block_padding">
    <div class="row no-gutters gutters-4 align-items-center">
      @for (setting of settings.controls; track setting; let id = $index) {
        <div class="col-12"
             [formGroupName]="id"
             [class.d-none]="!searchFieldError && searchField && searchFieldIds.indexOf(setting.value.id) === -1"
        >
          <div class="row no-gutters gutters-2 panel bg-white mb-3 p-2 pt-3 pb-3 mr-0 ml-0">
            <div class="col-6 col-sm-12 col-xl-3 caption-sm mb-2 mt-0 pt-2">{{setting.value.caption}}</div>
            <div class="col-6 col-md-3 pt-2">
              <app-material-input-checkbox formControlName="is_active">
                Принимать на реализацию
              </app-material-input-checkbox>
            </div>
            <!--          <div class="col-4">-->
            <!--            <app-material-input formControlName="voznagr_agenta" [placeholder]="'Вознаграждение агента (ДБ)'">-->
            <!--              Вознаграждение агента (ДБ)-->
            <!--            </app-material-input>-->
            <!--          </div>-->
            <!--          <div class="col-4">-->
            <!--            <app-material-input formControlName="dolya_subagenta_db" [placeholder]="'Процент субагента (ДБ)'">-->
            <!--              Процент субагента ДБ (Доля <span class="bold">{{ settings.controls[id].value['voznagr_agenta'] | partRate : settings.controls[id].value['dolya_subagenta_db'] : 'front'}}</span>)-->
            <!--            </app-material-input>-->
            <!--          </div>-->
            <div class="col-sm-6 col-md-3 col-xl-2">
              <app-material-input-datepicker formControlName="srok_realisation" [placeholder]="'Действует до'">
                Действует до
              </app-material-input-datepicker>
            </div>
            <div class="col-6 col-md-3 col-xl-2">
              <app-material-input formControlName="voznagr_agenta_from_ddu" [placeholder]="'Вознаграждение агента (ДДУ)'">
                Вознаграждение агента (ДДУ)
              </app-material-input>
            </div>
            <div class="col-6 col-md-3 col-xl-2">
              <app-material-input formControlName="dolya_subagenta_agd" [placeholder]="'Процент субагента (АГД)'">
                Процент субагента АГД (Доля <span class="bold">{{ settings.controls[id].value['voznagr_agenta_from_ddu'] | partRate : settings.controls[id].value['dolya_subagenta_agd'] : 'front'}}</span>)
              </app-material-input>
            </div>
            <!--          <div class="col-sm-12">-->
            <!--            <app-material-input formControlName="unique_term_days" [placeholder]="'Срок уникальности клиента'">-->
            <!--              Срок уникальности клиента-->
            <!--            </app-material-input>-->
            <!--          </div>-->
            <!--          <div class="col-sm-12">-->
            <!--            <app-material-input-checkbox formControlName="lead_transfer_capability">-->
            <!--              Возможность передачи лида субагентом-->
            <!--            </app-material-input-checkbox>-->
            <!--          </div>-->
            <!--          <div class="col-sm-12">-->
            <!--            <div [hidden]="!settings.controls[id].value['lead_transfer_capability']">-->
            <!--              <app-material-input formControlName="lead_transfer_sub_percent_db" [placeholder]="'Процент субагента ДБ при передаче лида'">-->
            <!--                Процент субагента ДБ при передаче лида-->
            <!--              </app-material-input>-->
            <!--              <app-material-input formControlName="lead_transfer_sub_percent_agd" [placeholder]="'Процент субагента АГД при передаче лида'">-->
            <!--                Процент субагента АГД при передаче лида-->
            <!--              </app-material-input>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row no-gutters gutters-4 align-items-center mt-4 mb-4">
    <div class="col-6">
      <button (click)="saveForm()" type="button" [disabled]="loading"
              class="button fixed_buttons_block_main" [ngClass]="{'button_disabled': loading}">
        Сохранить
      </button>
    </div>
  </div>
</form>
